import { render, staticRenderFns } from "./EntrepreneurVerticalNameItem.vue?vue&type=template&id=80bf56ae&scoped=true&"
import script from "./EntrepreneurVerticalNameItem.vue?vue&type=script&lang=js&"
export * from "./EntrepreneurVerticalNameItem.vue?vue&type=script&lang=js&"
import style0 from "./EntrepreneurVerticalNameItem.vue?vue&type=style&index=0&id=80bf56ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80bf56ae",
  null
  
)

export default component.exports